/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPublishRpc
 */

export let ComHubspotContentstagingRpcModelPublishEventIF;
(function (_ComHubspotContentstagingRpcModelPublishEventIF) {})(ComHubspotContentstagingRpcModelPublishEventIF || (ComHubspotContentstagingRpcModelPublishEventIF = {}));
export let ComHubspotContentstagingRpcModelStagedPageIF;
(function (_ComHubspotContentstagingRpcModelStagedPageIF) {})(ComHubspotContentstagingRpcModelStagedPageIF || (ComHubspotContentstagingRpcModelStagedPageIF = {}));
export const schedulePublishRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPublishRpc',
  rpcName: 'schedulePublish',
  auth: 'app',
  fingerprint: 'EX0I2fmUhljLQuXp4CTXD2PqKrzUUbJF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUrlDiscrepanciesRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPublishRpc',
  rpcName: 'getUrlDiscrepancies',
  auth: 'app',
  fingerprint: 'ZllXHHEqi0I4KG16yN9VtJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUrlConflictsRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPublishRpc',
  rpcName: 'getUrlConflicts',
  auth: 'app',
  fingerprint: 'ZllXHHEqi0I4KG16yN9VtGPqKrzUUbJF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummaryRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingPublishRpc',
  rpcName: 'getSummary',
  auth: 'app',
  fingerprint: 'yArLK5Ba2bvWOQJf4gnSJ2PqKrzUUbJF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};